export const criticisms = [
  // Governance & Ethics
  {
    id: 'market-games',
    title: "Market Games",
    description: "SEC battles, crypto influence, shareholder dynamics"
  },
  {
    id: 'tax-avoidance',
    title: "Tax Avoidance",
    description: "Wealth strategies vs. record tax payments"
  },
  {
    id: 'legal-regulatory',
    title: "Legal & Regulatory",
    description: "EU fines, global investigations, constitutional challenges"
  },
  {
    id: 'business-ethics',
    title: "Business Ethics",
    description: "Corporate governance, fiduciary duties"
  },
  // Product & Innovation
  {
    id: 'failed-promises',
    title: "Failed Promises",
    description: "FSD progress, Cybertruck reality, Mars timeline"
  },
  // Human Impact
  {
    id: 'labor-issues',
    title: "Labor Issues",
    description: "Union battles, safety records, NLRB challenges"
  },
  {
    id: 'twitter-chaos',
    title: "X/Twitter Chaos",
    description: "Platform transformation, content moderation"
  },
  {
    id: 'covid-stance',
    title: "COVID Stance",
    description: "Pandemic response, policy changes"
  },
  {
    id: 'personal-conduct',
    title: "Personal Conduct",
    description: "Political influence, free speech paradox"
  },
  // Environmental Footprint
  {
    id: 'environmental',
    title: "Environmental",
    description: "Tesla sustainability vs. xAI consumption"
  }
];

export const videos = [
  {
    id: 1,
    title: "Tesla Factory Working Conditions",
    embedId: "jvI5QIiMlcE"
  },
  {
    id: 2,
    title: "Twitter Takeover Chaos",
    embedId: "rWW-zwnpvjo"
  }
];
